export const LIVE_PET_CONTENT_KEY = 'live-pet-content';
